<template>
  <div
    id="app"
    class="l-main-container"
  >
    <div class="l-notification">
      <ws-notifications />
    </div>
    <ws-header
      class="ws-header"
      :title="$t('Цифровая платформа: демонстрационный экзамен')"
      :show-role-select="true"
    >
      <template v-slot:breadcrumb>
        <router-link
          to="/"
          class="ws-breadcrumb__item ws-breadcrumb__item--home"
        >
          <ws-icon
            name="arrow-thin"
            color="#fff"
            :fill="false"
            width="12"
            height="11"
          />
        </router-link>
        <router-link
          v-if="currentPath"
          :to="currentPath.link"
          class="ws-breadcrumb__item"
        >
          {{ currentPath.title }}
        </router-link>
      </template>
    </ws-header>
    <ws-sidebar class="ws-sidebar">
      <nav class="ws-sidebar-nav">
        <ul class="ws-sidebar-nav__list">
          <li
            class="ws-sidebar-nav__item"
            v-for="item in navigation"
            :key="item.link"
          >
            <ws-permission-node
              :resources="item.resources"
              :actions="['read']"
              @permissions="setNavigationPermission"
            >
              <router-link
                class="ws-sidebar-nav__link"
                :to="item.link"
                active-class="is-active"
                v-if="item.show"
              >
                <ws-icon
                  :name="item.icon"
                  :title="item.title"
                  color="#fff"
                  width="32"
                  height="32"
                />
              </router-link>
            </ws-permission-node>
          </li>
        </ul>
      </nav>
    </ws-sidebar>
    <ws-main-view class="ws-main-view">
      <b-loading
        :is-full-page="false"
        :active.sync="isPending"
        :can-cancel="true"
      ></b-loading>
      <ws-error-handler />
      <router-view />
    </ws-main-view>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import WsNotifications from '@/components/notifications/WsNotifications.vue'

export default {
  name: 'App',
  components: {
    WsNotifications
  },
  data () {
    return {
      navigation: [
        {
          icon: 'request',
          title: this.$t('Заявки на демонстрационный экзамен'),
          link: '/requests',
          resources: ['services/de/demoexam', 'services/de/demoexammy'],
          show: false,
          only: [
            'front_rcc',
            'front_university',
            'front_dep',
            'front_education_ministry',
            'front_admin',
            'front_curator',
            'front_curator_institution'
          ]
        },
        {
          icon: 'list',
          title: this.$t('Демонстрационные экзамены и экзаменационные группы'),
          link: '/demo-exams',
          resources: ['services/de/demoexam', 'services/de/demoexammy'],
          show: false,
          only: [
            'front_rcc',
            'front_university',
            'front_dep',
            'front_education_ministry',
            'front_admin',
            'front_me',
            'front_tech_expert',
            'front_le',
            'front_mc',
            'front_mio',
            'front_50plus',
            'front_curator',
            'front_curator_institution',
            'front_auditor'
          ]
        },
        {
          icon: 'de-center',
          title: this.$t('ЦПДЭ'),
          link: '/de-center',
          resources: ['services/de/cpde'],
          show: false,
          only: [
            'front_rcc',
            'front_university',
            'front_dep',
            'front_education_ministry',
            'front_admin',
            'front_curator',
            'front_curator_institution',
            'front_assessor',
            'front_auditor'
          ]
        },
        {
          icon: 'orgs',
          title: this.$t('Организации и предприятия'),
          link: '/orgs',
          resources: ['services/de/organizations'],
          show: false,
          only: [
            'front_rcc',
            'front_university',
            'front_dep',
            'front_education_ministry',
            'front_admin',
            'front_curator',
            'front_curator_institution'
          ]
        },
        {
          icon: 'reports',
          title: this.$t('Отчеты и Выгрузки'),
          link: '/reports',
          resources: ['services/de/demoexam'],
          show: false,
          only: [
            'front_dep',
            'front_education_ministry',
            'front_admin',
            'front_rcc',
            'front_mc'
          ]
        },
        {
          icon: 'experts',
          title: this.$t('Эксперты'),
          link: '/experts',
          resources: ['services/de/cpde'],
          show: false,
          only: [
            'front_admin',
            'front_rcc',
            'front_dep'
          ]
        }
      ]
    }
  },
  watch: {
    getUserGuid: {
      deep: true,
      immediate: true,
      handler () {
        if (this.getUserGuid) {
          const item = this.getUserSourcesPermission.find(item => item.guid === this.getUserGuid)
          if (item && item.navigation) {
            this.navigation = [{
              icon: 'list',
              title: this.$t('Демонстрационные экзамены'),
              link: '/demo-exams'
            }]
            this.$router.push('/demo-exams')
          }
        }
      }
    }
  },
  computed: {
    ...mapState('authentication', {
      currentRole: 'currentRole',
      isAuthPending: 'isFindPending'
    }),
    ...mapState('profile', {
      isProfilePending: 'isFindPending'
    }),
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid']),
    isPending () {
      return this.isAuthPending || this.isProfilePending
    },
    currentPath () {
      return this.navigation.find(item => this.$route.path.match(item.link))
    }
  },
  methods: {
    setNavigationPermission (item) {
      this.navigation.forEach(n => {
        if (n.resources.indexOf(item.resource) > -1 && n.only.indexOf(this.currentRole) > -1) {
          if (item.read) {
            n.show = true
          }
        }
      })
    }
  }
}
</script>
